// ===================================================================
// Rótulos de exibição (PT) — recursos, histórico, atendimento especial
// ===================================================================

/** appeal_type / resource_type na UI (admin, analista, candidato). */
export const APPEAL_TYPE_LABELS = {
  exemption: 'Isenção',
  list: 'Lista de inscritos',
  enrolled_list: 'Lista de inscritos',
  registration_list: 'Lista de inscritos',
  preliminary_result: 'Resultado preliminar',
  answer_key: 'Gabarito',
  special_attendance: 'Atendimento especial',
  analysis: 'Recurso de análise',
};

export const getAppealTypeLabel = (type) => {
  const key = String(type || '').toLowerCase();
  if (!key) return 'Recurso de isenção';
  return APPEAL_TYPE_LABELS[key] || (type ? `Recurso (${type})` : 'Recurso de isenção');
};

/** analysis_history.analysis_type */
export const ANALYSIS_HISTORY_TYPE_LABELS = {
  curricular: 'Análise curricular',
  exemption: 'Isenção',
  special_attendance: 'Atendimento especial',
  appeal_special_attendance: 'Recurso de atendimento especial',
  appeal_list: 'Recurso contra lista de inscritos',
  appeal_exemption: 'Recurso de isenção',
  appeal_result_preliminary: 'Recurso de resultado preliminar',
  appeal_answer_key: 'Recurso contra o gabarito',
  appeal_return_post_decision: 'Recurso — devolução pós-decisão',
  appeal_response_published: 'Recurso — publicação ao candidato',
};

/** analysis_history.action */
export const ANALYSIS_HISTORY_ACTION_LABELS = {
  approved: 'Deferido',
  rejected: 'Indeferido',
  removed: 'Removido',
  returned: 'Devolvido',
  published: 'Publicado',
  pending: 'Pendente',
  analyzing: 'Em análise',
};

export const getAnalysisHistoryTypeLabel = (type, backendLabel) => {
  const key = String(type || '').toLowerCase();
  const fromMap = ANALYSIS_HISTORY_TYPE_LABELS[key];
  if (fromMap) return fromMap;
  const bl = (backendLabel || '').trim();
  if (bl && bl !== type && bl !== key) return bl;
  return type || '—';
};

export const getAnalysisHistoryActionLabel = (action, backendLabel) => {
  if (backendLabel) return backendLabel;
  const key = String(action || '').toLowerCase();
  return ANALYSIS_HISTORY_ACTION_LABELS[key] || action || '—';
};

/** Cabeçalho da coluna de pontuação no histórico (prova = Nota; ordem = Ordem inscr.). */
export const getHistoryScoreColumnLabel = (selectionMode) => {
  const mode = String(selectionMode || '').toLowerCase();
  if (mode === 'prova') return 'Nota';
  if (mode === 'ordem_inscricao') return 'Ordem inscr.';
  return 'Média';
};
